import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';
import type { CalendarViewTypeEnum } from 'owa-calendar-view-type';

/**
 * Action invoked when user selects a calendar view type from Ribbon, Command bar, or hotkey
 *
 * @param newCalendarViewType calendar view type to change to
 * @param newNumOfDaysInDayRange number of days to include in visible range if day view
 * @param isSavedViewSelected if a saved view is selected
 */
export const changeCalendarViewType = action(
    'changeCalendarViewType',
    (
        newCalendarViewType: CalendarViewTypeEnum,
        newNumOfDaysInDayRange?: number,
        isSavedViewSelected?: boolean
    ) =>
        addDatapointConfig(
            {
                name: 'changeCalendarViewType',
                customData: {
                    owa_1: newCalendarViewType,
                },
            },
            {
                newCalendarViewType,
                newNumOfDaysInDayRange,
                isSavedViewSelected,
            }
        )
);
